<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form">
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="cours-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="cours-search" type="text" :placeholder='t("Mots clés")' v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="codes">{{ t("Code") }}</label>
                        <select @change="changeSelectionCode()" class="o-select" id="codes" v-model="selectedCode">
                            <option value="">{{ t("Code") }}</option>
                            <option v-for="code in codes" :value="code">{{ code }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="cycle">{{ t("Cycle") }}</label>
                        <select @change="changeSelectionCycle()" class="o-select" id="cycle" v-model="selectedCycle">
                            <option value="">{{ t("Cycle") }}</option>
                            <option v-for="cycle in cycles" :value="cycle">{{ cycle }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__button c-tooltip__wrap">
                        <button class="o-button -button-bg" type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }} <span class="sr-only">{{ t("un cour selon les critères sélectionnés") }}</span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="c-programmes-search__filters">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div class="c-programmes-search__filters__total">
                    <span>
                        {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                    </span>
                </div>
                <div v-if="tags.length" class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.title }}
                        </span>
                        <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                        </button>
                    </div>
                </div>
                <div class="c-programmes-search__filters__reset">
                    <button @click.prevent="resetSearch()" class="o-button -button-reset">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="o-section__inner" :class="{'-loading': loading}">
        <div class="o-container">
            <div ref="resultsStart" class="c-projects-search__results">
                <template v-for="entry in filteredResultsPaged">
                    <div class="c-search-results__item -show">
                        <div class="c-search-result__header">
                            <span class="c-search-result__title o-title-4">
                                <a :href="entry.url">{{ entry.code }} - {{ entry.title }}</a>
                            </span>
                        </div>
                        <div class="c-search-result__desc">
                            <p>
                                {{ entry.description }}
                            </p>
                        </div>
                        <div class="c-search-result__tags">
                            <span v-if="entry.code" class="o-tag">
								{{ entry.code.replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-if="entry.cycle" class="o-tag">
								{{ entry.cycle.replace(/<[^>]*>?/gm, '') }}
                            </span>
                        </div>
                </div>
                </template>
            </div>
            <Pager v-if="pagerInfo.totalPages>1" :pagerInfo="pagerInfo" @goToPage="goToPage" />
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import Pager from './Pager.vue';

    export default {
        props: {
            background: {
                type: String,
                default: ''
            }
        },
        components: {
            Pager
        },
        data() {
            return {
                siteId: 1,
                loading: false,
                searchInput: '',
                searchedIds: null,
                selectedCycle: '',
                selectedCode: '',
                selectedCodes:[],
                selectedCycles:[],
                codes: [],
                cycles: [],
                results: [],
                controller: null,
                pagerInfo: {
                    currentPage: 1,
                    totalPages: 1
                },
                languageUrl: '/',
            }
        },
        mounted() {
            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }

            //load query params
            const currentUrl = new URL(window.location.href);
            const query = currentUrl.search;
            const urlParams = new URLSearchParams(query);
            if (urlParams.has('codes')) {
                this.selectedCodes = urlParams.get('codes').split(',');
            }
            if (urlParams.has('cycles')) {
                this.selectedCycles = urlParams.get('cycles').split(',');
            }
            if (urlParams.has('s')) {
                this.searchInput = urlParams.get('s');
            }

            this.fetchAttributes();
            if (this.searchInput.length >= 3) this.search();
            //console.log(ProjectLocalisation["Mots clés"])
        },
        computed: {
            filteredResults() {
                let filtered = this.results;

                if (this.searchedIds!==null) {
                    if (this.searchedIds.length === 0) return [];
                    filtered = filtered.filter(entry => {
                        return this.searchedIds.includes(entry.id);
                    });

                    filtered.sort((a, b) => {
                        return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                    });
                }

                if (this.selectedCodes.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedCodes.some(code => entry.code3 == code);
                    });
                }

                if (this.selectedCycles.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedCycles.some(cycle => entry.cycle == cycle);
                    });
                }

                this.pagerInfo.totalPages = Math.ceil(filtered.length / 10);
                this.pagerInfo.currentPage = 1;

                return filtered;
            },
            filteredResultsPaged() {
                return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 10, this.pagerInfo.currentPage * 10);
            },
            tags() {
                let tags = [];

                this.selectedCodes.forEach(code => tags.push({type: 'code', title: code}));
                this.selectedCycles.forEach(cycle => tags.push({type: 'cycle', title: cycle}));
                return tags
            }
        },
        methods: {
            t(string) {
                return CoursLocalisation[string];
            },
            fetchAttributes() {
                this.loading = true;
                fetch(this.languageUrl + 'api/search/cours-index?siteId=' + this.siteId, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.codes !== undefined) this.codes = data.codes;
                    if (data.cycles !== undefined) this.cycles = data.cycles;
                    if (data.results !== undefined) this.results = data.results;

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 10);
                    this.loading = false;
                })
            },
            goToPage(page) {
                this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    this.pagerInfo.currentPage = page;
                }, 100);
            },
            changeSelectionCode() {
                let current = this.selectedCode;
                if (current === '') return;
                if (!this.selectedCodes.includes(current)) {
                    this.selectedCodes.push(current);
                }
                this.selectedCode = '';
                this.refreshUrlQuery();
            },
            changeSelectionCycle() {
                let current = this.selectedCycle;
                if (current === '') return;
                if (!this.selectedCycles.includes(current)) {
                    this.selectedCycles.push(current);
                }
                this.selectedCycle = '';
                this.refreshUrlQuery();
            },
            removeTag(tag) {
                if (tag.type === 'code') {
                    this.selectedCodes = this.selectedCodes.filter(code => code !== tag.title);
                } else {
                    this.selectedCycles = this.selectedCycles.filter(cycle => cycle !== tag.title);
                }
                this.refreshUrlQuery();
            },
            keyupSearch: debounce(function(e) {
                if (this.controller) this.controller.abort();
                if (this.searchInput.length >= 3) {
                    this.search();
                } else {
                    this.searchedIds = null;
                }
            }, 500),
            search () {
                this.loading = true;
                if (this.controller) {
                    this.controller.abort();
                }

                this.controller = new AbortController();

                fetch(this.languageUrl + 'api/search/cours?s='+this.searchInput+'&siteId='+this.siteId, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        this.searchedIds = data;
                        this.loading = false;
                        this.refreshUrlQuery();
                    })
                    .catch(err => {
                        this.searchedIds = null;
                        this.searchInput = '';
                        this.loading = false;
                        this.refreshUrlQuery();
                    });
            },
            resetSearch() {
                this.searchInput = '';
                this.searchedIds = null;
                this.selectedCodes = [];
                this.selectedCycles = [];
                this.refreshUrlQuery();
            },
            refreshUrlQuery() {
                let query = '';
                if (this.selectedCodes.length > 0) {
                    query += 'codes=' + this.selectedCodes.join(',') + '&';
                }
                if (this.selectedCycles.length > 0) {
                    query += 'cycles=' + this.selectedCycles.join(',') + '&';
                }
                if (this.searchInput) {
                    query += 's=' + this.searchInput;
                }
                const currentUrl = new URL(window.location.href);
                let pathName = currentUrl.pathname;
                pathName = pathName.replace(/(p\d)/, '');
                let newUrl = currentUrl.origin + pathName + '?' + query;
                if (this.target) {
                    newUrl = this.target + '?' + query;
                    window.location.href = newUrl;
                }
                window.history.pushState({path:newUrl},'',newUrl);
            },
        },
    }
</script>